import axios from 'axios';

import { MFBEvent } from 'types/models/event';
import { TriggerId } from 'types/models/trigger';
import { APIResponseParsed } from 'types/response';
import { getRequest } from 'utils/HttpRequest/http-request-utils';

import { parseAxiosError } from './utils/parse-axios-error';

type DateRangeIso = { startDateIso: string, endDateIso: string };

async function fetchEventsByTriggers(
  triggerIds: TriggerId[],
  dateRange: DateRangeIso
): Promise<APIResponseParsed<MFBEvent[]>> {
  try {
    const filter: string[] = [
      `triggerId||$in||${triggerIds.join(',')}`,
      `date||$gte||${dateRange.startDateIso}`,
      `date||$lte||${dateRange.endDateIso}`
    ];
    const params = { filter };
    const response = await getRequest<MFBEvent[]>('event', { params });
    return { data: response.data, error: null };
  } catch (error) {
    if (!axios.isAxiosError(error)) throw error;
    return { data: null, error: parseAxiosError(error) };
  }
}

// ================================================
// EXPORTS
// ================================================
export default {
  fetchEventsByTriggers
};
